// extracted by mini-css-extract-plugin
export default {"inputContainer":"InputWithLabel_inputContainer__VSYZ5","icon":"InputWithLabel_icon__H4GX7"};